import { TablePagination } from '@mui/material';

const defaultRowsPerPageOptions = [10, 25, 50];

export type PaginationConfig = {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
};

export const TablePaginationComp = ({
  totalItems,
  currentPage,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = defaultRowsPerPageOptions,
}: PaginationConfig) => (
  <TablePagination
    component='div'
    count={totalItems}
    page={currentPage - 1}
    onPageChange={(_event, newPage) => onPageChange(newPage + 1)}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={(event) =>
      onRowsPerPageChange(parseInt(event.target.value, 10))
    }
    rowsPerPageOptions={rowsPerPageOptions}
    labelRowsPerPage='Resultados por página'
  />
);
